import { render, staticRenderFns } from "./AddNewItemCard.vue?vue&type=template&id=238906da&scoped=true"
import script from "./AddNewItemCard.vue?vue&type=script&lang=ts"
export * from "./AddNewItemCard.vue?vue&type=script&lang=ts"
import style0 from "./AddNewItemCard.vue?vue&type=style&index=0&id=238906da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238906da",
  null
  
)

export default component.exports